import React, { useCallback, useState } from 'react';
import {
	Button,
	Modal, Space, Spinner, Title,
} from '@components';
import { MeetingListItem } from '@api';

interface DeleteMeetingModalProps {
	onMeetingDeleteConfirm: (meetingId: string) => Promise<void>,
    meetingInfo: MeetingListItem,
	closeModal: () => void,
}

function DeleteMeetingModal(props: DeleteMeetingModalProps): JSX.Element {
	const {
		closeModal,
		onMeetingDeleteConfirm,
        meetingInfo,
	} = props;

    const [isDeleting, setIsDeleting] = useState<boolean>(false);

	const handleSubmit = useCallback(async () => {
        setIsDeleting(true);
		await onMeetingDeleteConfirm(meetingInfo.id);
		closeModal();
	}, [onMeetingDeleteConfirm, closeModal, meetingInfo]);

	return (
		<Modal isOpen>
			<Space alignment="vertical">
				<Title centered>
					Удалить собрание «{meetingInfo.subject}»?
				</Title>
				<Space alignment="vertical" gap="20px">
					<div>
						После удаления собрание не подлежит восстановлению
					</div>
					<Space centered>
                        {isDeleting ? <div className='delete-modal__spinner'><Spinner /></div> : null}
						<Button theme="primary" onClick={handleSubmit} disabled={isDeleting}>
							Удалить
						</Button>
						<Button onClick={closeModal} disabled={isDeleting}>
							Отменить
						</Button>
					</Space>
				</Space>
			</Space>
		</Modal>
	);
}

export { DeleteMeetingModal };